export default __webpack_public_path__ + "static/landing-banner-b6501bb636857f5e1f1b2e271e8fc329.webp";